// Central config for all external destinations. Change values here to update site-wide links.
const WHATSAPP_NUMBER = "919538315755"; // country code + number, no + or spaces
const WHATSAPP_MESSAGE = "Hi Auxieron, I'd like to talk to an expert about my financial plan.";

export const CONFIG = {
  brand: "Auxieron",
  legalName: "Auxieron Pvt. Ltd.",
  tagline: "One Partner. Every Financial Solution.",
  subline: "Investments, insurance, tax, fixed income, loans and planning — brought together and built around your goals.",
  location: "Bhubaneswar, Odisha, India",
  address: "Raghunathpur, Nandankanan Road, Bhubaneswar, 751024",
  website: "https://auxieron.com",
  websiteLabel: "Auxieron.com",
  instagramHandle: "@auxieron",
  instagramUrl: "https://instagram.com/auxieron",
  phone: "+91 95383 15755",
  phoneHref: "tel:+919538315755",
  whatsappUrl: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
  logo: "/auxieron-logo.webp",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return false;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  return true;
};

// Scroll to the lead form if present on the page, else navigate to /contact
export const goToLeadForm = (navigate) => {
  if (!scrollToId("lead-form")) navigate("/contact#lead-form");
};

export const NAV_LINKS = [
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Learn", to: "/learn" },
  { label: "Calculators", to: "/calculators" },
  { label: "Contact", to: "/contact" },
  { label: "Book a Call", to: "/book" },
];

const WA = "919538315755";
export const whatsappFor = (topic) =>
  `https://wa.me/${WA}?text=${encodeURIComponent(
    `Hi Auxieron, I'd like to know more about ${topic}.`
  )}`;
